// App
const INIT_APP = 'INIT_APP';
const SET_APP_SETTINGS = 'SET_APP_SETTINGS';
const EXPORT_ITEM = 'EXPORT_ITEM';
const EXPORT_ITEM_SUCCESS = 'EXPORT_ITEM_SUCCESS';
const DOWNLOAD_ITEM = 'DOWNLOAD_ITEM';

// Authentication
const LOGIN = 'LOGIN';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGOUT = 'LOGOUT';

// Content
const GET_CONTENT = 'GET_CONTENT';
const GET_CONTENT_SUCCESS = 'GET_CONTENT_SUCCESS';
const GET_CONTENT_FAILED = 'GET_CONTENT_FAILED';
const SELECT_FOLDER = 'SELECT_FOLDER';
const SELECT_FILE = 'SELECT_FILE';
const GET_FEATURE = 'GET_FEATURE';
const GET_FEATURE_SUCCESS = 'GET_FEATURE_SUCCESS';
const GET_FEATURE_FAILED = 'GET_FEATURE_FAILED';
const ENABLE_EXTRACT = 'ENABLE_EXTRACT';
const ENABLE_EXTRACT_SUCCESS = 'ENABLE_EXTRACT_SUCCESS';
const ENABLE_EXTRACT_FAILED = 'ENABLE_EXTRACT_FAILED';

export {
  INIT_APP,
  SET_APP_SETTINGS,
  EXPORT_ITEM,
  EXPORT_ITEM_SUCCESS,
  DOWNLOAD_ITEM,
  LOGIN,
  LOGIN_SUCCESS,
  LOGOUT,
  GET_CONTENT,
  GET_CONTENT_SUCCESS,
  GET_CONTENT_FAILED,
  SELECT_FOLDER,
  SELECT_FILE,
  GET_FEATURE,
  GET_FEATURE_SUCCESS,
  GET_FEATURE_FAILED,
  ENABLE_EXTRACT,
  ENABLE_EXTRACT_SUCCESS,
  ENABLE_EXTRACT_FAILED
};
